import { factory as factoryABI } from '@jdiyield/abi'
import { ChainID } from '@jdiyield/constants'
import { Balance, BalanceLP, Platform, PriceList, Token } from '@jdiyield/interfaces'
import Web3 from 'web3'

import { getLpTokenAssets } from './assets'
import { calculateBalanceLP, calculateBalanceSingle } from './calculate'
import getNodeUrl from './rpcRandom'
import { allBalancesOf, makeBatchRequestIncludeError } from './utils'

interface queryLpTokenProps {
  web3?: Web3
  account: string
  platform: Platform
  tokens: Token[]
  baseLPGenerate: Token[]
  priceList: PriceList
  chainID: ChainID
}

export const queryLpToken = async ({
  web3: web3Prop,
  account,
  platform,
  tokens,
  baseLPGenerate,
  priceList,
  chainID
}: queryLpTokenProps): Promise<(Balance | BalanceLP)[]> => {
  try {
    const web3 = web3Prop || new Web3(getNodeUrl(chainID))

    if (platform?.specialCaseTokens) {
      const tokenBalances = await allBalancesOf(
        web3,
        account,
        platform?.specialCaseTokens.map(({ address }) => address),
        chainID
      )

      const result = await Promise.all(
        platform.specialCaseTokens
          .filter((tokenInfo) => {
            const balance =
              tokenBalances.find(({ contract }) => contract.toLowerCase() === tokenInfo.address.toLowerCase())
                ?.balance || '0'
            return balance !== '0'
          })
          .map(async (tokenInfo) => {
            const balance =
              tokenBalances.find(({ contract }) => contract.toLowerCase() === tokenInfo.address.toLowerCase())
                ?.balance || '0'

            return await calculateBalanceSingle(
              web3,
              {
                balance,
                pool: 0,
                lpAddress: tokenInfo.address,
                availableBalanceOf: '0'
              },
              [...tokens, tokenInfo],
              priceList
            )
          })
      )
      return result
    }

    if (!platform?.factories || platform?.factories?.length === 0) {
      return []
    }
    // GET LP from generate all tokens and use TokenA & TokenB address to call getPair from factory
    let pairAddressesPromise = platform.factories.flatMap((factory) => {
      const factoryContract = new web3.eth.Contract(factoryABI as any, factory.factoryAddress)
      return baseLPGenerate.map((pairTokens) => {
        return factoryContract.methods.getPair(pairTokens[0].address, pairTokens[1].address).call
      })
    })

    let pairAddresses = await makeBatchRequestIncludeError(web3, pairAddressesPromise)
    const filteredAddress = pairAddresses
      .filter((address) => !!address && address !== '0x0000000000000000000000000000000000000000')
      .map((lp) => ({ address: lp })) as any

    const lpTokenAssets = await getLpTokenAssets({
      walletAddress: account,
      lpTokens: filteredAddress,
      chainID,
      web3Prop
    })

    let fetchBalanceLPs = lpTokenAssets.map((lp) => {
      const lpMapping = {
        ...lp,
        lpAddress: lp.token?.address
      }
      return calculateBalanceLP(web3, lpMapping as any, null, tokens, priceList)
    })

    let fetchBalanceResult = await Promise.all(fetchBalanceLPs)
    const result = fetchBalanceResult.filter((result) => !!result)

    fetchBalanceResult = null
    fetchBalanceLPs = null
    pairAddressesPromise = null
    pairAddresses = null
    baseLPGenerate = null

    return result
  } catch (error) {
    console.log(error)
    return []
  }
}

// async function getLPAssetFromGenerate(account: string, chainID: ChainID, platform: Platform, lpGenerate: Token[]) {
//   const lpTokenAddresses = platform.factories.reduce((acc, factory) => {
//     const lpTokensData = lpGenerate.map((tokens) => {
//       return getLPAddress(tokens[0], tokens[1], factory.factoryAddress, factory.initCodeHash)
//     })
//     acc = [...acc, ...lpTokensData]
//     return acc
//   }, [])

//   const newLpTokenAssets = await getLpTokenAssets(
//     account,
//     lpTokenAddresses.map((lp) => ({ address: lp })) as any,
//     chainID
//   )

//   return (
//     newLpTokenAssets.map((lp) => ({
//       ...lp,
//       routerAddress: platform.contracts[0].routerAddress,
//       platformName: platform.name
//     })) ?? []
//   )
// }
